module.exports = __webpack_public_path__ + "img/speaker-NinoGordeladze.231ab470.png";